import { render, staticRenderFns } from "./DocDigitalInputs.vue?vue&type=template&id=2f27a96a&"
import script from "./DocDigitalInputs.vue?vue&type=script&lang=js&"
export * from "./DocDigitalInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f27a96a')) {
      api.createRecord('2f27a96a', component.options)
    } else {
      api.reload('2f27a96a', component.options)
    }
    module.hot.accept("./DocDigitalInputs.vue?vue&type=template&id=2f27a96a&", function () {
      api.rerender('2f27a96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/DocDigitalInputs.vue"
export default component.exports